// src/pages/resume/summary.js
import React, { useState } from 'react'; // Import useState
import { useParams } from 'react-router-dom';
import FormTextarea from '../../components/resume/FormTextarea';
import { useResume } from '../../context/ResumeContext';
import FeedbackModal from '../../components/common/FeedbackModal'; // <-- Import reusable modal
import useAutosave from '../../hooks/useAutosave';
import SaveStatusChip from '../../components/resume/editor/SaveStatusChip';

const Summary = () => {
    const { summary, setSummary, jobDescription } = useResume();
    const { resumeId } = useParams();

    // --- ADDED: Modal state ---
    const [modalInfo, setModalInfo] = useState({ isOpen: false, message: '', title: '', isError: false });

    const handleAiWrite = () => {
        if (!jobDescription) {
            // --- REPLACED: alert with modal ---
            setModalInfo({
                isOpen: true,
                title: 'AI Write Error',
                message: 'Please add a job description in the "AI Keyword Analysis" tab first to get an AI-powered summary.',
                isError: true
            });
            return;
        }

        // Placeholder for your actual AI logic
        const aiSummary = "Driven and analytical Data Scientist with 5 years of experience in machine learning and statistical modeling. Proven track record of developing data-driven solutions that drive business growth and efficiency. Proficient in Python, SQL, and AWS.";
        setSummary(aiSummary);
    };

    const handleSave = async () => {
        const response = await fetch('https://renaisons.com/api/save_summary.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                resume_id: resumeId,
                summary: summary // This perfectly matches $data->summary in your PHP!
            }),
            credentials: 'include' // <-- ADD THIS LINE
        });

        const result = await response.json();

        if (!response.ok || result.status !== 'success') {
            throw new Error(result.message || 'save failed');
        }
    };

    const { status, retry } = useAutosave({ sectionKey: 'summary', data: summary, save: handleSave });

    return (
        <>
            {/* --- ADDED: Render the modal --- */}
            {modalInfo.isOpen && (
                <FeedbackModal
                    title={modalInfo.title}
                    message={modalInfo.message}
                    isError={modalInfo.isError}
                    onClose={() => setModalInfo({ isOpen: false, message: '', title: '', isError: false })}
                />
            )}

            <div className="space-y-6">
                <div>
                    <div className="flex justify-between items-center mb-2">
                        <button
                            type="button"
                            onClick={handleAiWrite}
                            className="bg-cyan-500 hover:bg-cyan-400 text-black text-xs font-semibold py-1 px-3 rounded-md"
                        >
                            AI Write Summary
                        </button>
                        <SaveStatusChip status={status} onRetry={retry} />
                    </div>
                    <FormTextarea
                        id="summary"
                        name="summary"
                        value={summary}
                        onChange={(e) => setSummary(e.target.value)}
                        placeholder="e.g., Driven Data Scientist with 5 years of experience..."
                        rows="10"
                        aria-label="Professional summary"
                    />
                    <p className="text-xs text-gray-400 mt-2">Write a brief summary of your career, skills, and goals.</p>
                </div>
            </div>
        </>
    );
};

export default Summary;
